import {
  NXGDSStatusVariant,
  type NXGDSNotificationProps,
} from "@nsftx/seven-nxg-design-system-backoffice";
import { logger } from "@/v2/utils/logger";
import { getApiErrorMessage } from "@/v2/api/response";
import { isHttpError } from "@/v2/api/errors";
import { NOTIFY_DEFAULTS } from "./defaults";
import { addNotification } from "./notify.store";

export function notify(
  options: Pick<NXGDSNotificationProps, "variant" | "text"> &
    Partial<Omit<NXGDSNotificationProps, "variant" | "text">>,
): string {
  const text = options.text.trim();
  if (!text) {
    logger.warn("notify", "text is required");
    return "";
  }

  const id = crypto.randomUUID();
  addNotification(id, { ...NOTIFY_DEFAULTS, ...options, text });
  return id;
}

export function notifyApiError(error: unknown, fallback: string): void {
  const text = isHttpError(error)
    ? error.message
    : getApiErrorMessage(error, fallback);

  notify({
    variant: NXGDSStatusVariant.Negative,
    text,
  });
}

export function notifyApiSuccess(text: string): void {
  notify({
    variant: NXGDSStatusVariant.Positive,
    text,
  });
}
